import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { FinalReelDisplay } from './FinalReelDisplay';
import { RegenerateMediaModal } from './v2/RegenerateMediaModal';
import type { IReelScene } from '@/@types/reelScenes';
import type { Id } from '../../../convex/_generated/dataModel';

interface IRegenerateModalWrapperProps {
  selectedScene: IReelScene | null;
  effectiveImagePrompt: string | null;
  isRegenModalOpen: boolean;
  onCloseRegenModal: () => void;
  firstFrameUrl: string | null;
  lastFrameUrl: string | null;
  videoUrl: string | null;
  singleImageSceneId: Id<'reelScenes'> | null;
  singleImageFrame: string | null;
  onRegenerateImage: (frame: 'first' | 'last', prompt: string) => void;
}

export function RegenerateModalWrapper({
  selectedScene,
  effectiveImagePrompt,
  isRegenModalOpen,
  onCloseRegenModal,
  firstFrameUrl,
  lastFrameUrl,
  videoUrl,
  singleImageSceneId,
  singleImageFrame,
  onRegenerateImage,
}: IRegenerateModalWrapperProps) {
  if (!selectedScene || !effectiveImagePrompt) return null;

  return (
    <RegenerateMediaModal
      open={isRegenModalOpen}
      onClose={onCloseRegenModal}
      scene={selectedScene}
      firstFrameUrl={firstFrameUrl}
      lastFrameUrl={lastFrameUrl}
      videoUrl={videoUrl}
      firstFramePrompt={effectiveImagePrompt}
      lastFramePrompt={selectedScene.editedImagePrompt ?? selectedScene.imagePrompt}
      videoPrompt={selectedScene.videoPrompt ?? ''}
      onRegenerateImage={onRegenerateImage}
      onRegenerateVideo={() => {
        /* TODO */
      }}
      isRegeneratingFirstFrame={
        singleImageSceneId === selectedScene._id && singleImageFrame === 'first'
      }
      isRegeneratingLastFrame={
        singleImageSceneId === selectedScene._id && singleImageFrame === 'last'
      }
      isRegeneratingVideo={false}
    />
  );
}

interface IFinalVideoDialogProps {
  showFinalVideo: boolean;
  setShowFinalVideo: (show: boolean) => void;
  reelId: Id<'reels'>;
}

export function FinalVideoDialog({
  showFinalVideo,
  setShowFinalVideo,
  reelId,
}: IFinalVideoDialogProps) {
  return (
    <Dialog open={showFinalVideo} onOpenChange={setShowFinalVideo}>
      <DialogContent className="h-[100dvh] max-h-[100dvh] w-screen max-w-none rounded-none border-none bg-background/80 backdrop-blur-md p-0 flex flex-col items-center justify-center gap-0 [&>button[data-slot=dialog-close]]:top-6 [&>button[data-slot=dialog-close]]:right-6">
        <DialogHeader className="sr-only">
          <DialogTitle>Final Video</DialogTitle>
        </DialogHeader>
        <FinalReelDisplay reelId={reelId} fullscreen />
      </DialogContent>
    </Dialog>
  );
}
